import { ArrayType, NumberType, ObjectType, StringType } from '@hb/map-convert';
import { isString } from '../is';
import dateToTimestamp from '../lodash/dateToTimestamp';
function convertTimestamp(timestamp) {
    try {
        if (isString(timestamp))
            return dateToTimestamp(timestamp);
    }
    catch (e) {
        // nothing
    }
    return timestamp;
}
var citiesType = {
    name: StringType(),
    num: NumberType(),
    citycode: StringType('cityCode'),
    adcode: StringType('adCode'),
};
var suggestionType = {
    keywords: ArrayType(StringType(), 'keys'),
    key_word: StringType('keywords'),
    cities: ArrayType(ObjectType(citiesType)),
};
var indoorDataType = {
    floor: StringType(),
    truefloor: StringType('trueFloor'),
    cmsid: StringType('cmsId'),
    cpid: StringType(),
};
var bizExtType = {
    rating: StringType(),
    cost: StringType(),
    meal_ordering: StringType('mealOrdering'),
    seat_ordering: StringType('seatOrdering'),
    ticket_ordering: StringType('ticketOrdering'),
    hotel_ordering: StringType('hotelOrdering'),
};
var poiChildrenType = {
    id: StringType(),
    name: StringType(),
    location: StringType(),
    address: StringType(),
    distance: StringType(),
    subtype: StringType('subType'),
    typecode: StringType('typeCode'),
    sname: StringType(),
};
var poiType = {
    id: StringType(),
    parent: StringType(),
    childtype: StringType('childType'),
    name: StringType(),
    tag: StringType(),
    type: StringType(),
    typecode: StringType('typeCode'),
    biz_type: StringType('bizType'),
    address: StringType(),
    location: StringType(),
    tel: StringType(),
    postcode: StringType('postCode'),
    website: StringType(),
    email: StringType(),
    pcode: StringType(),
    pname: StringType(),
    citycode: StringType('cityCode'),
    cityname: StringType('cityName'),
    adcode: StringType('adCode'),
    adname: StringType('adName'),
    importance: StringType(),
    shopid: StringType('shopId'),
    shopinfo: StringType('shopInfo'),
    poiweight: StringType('poiWeight'),
    gridcode: StringType('gridCode'),
    distance: StringType(),
    navi_poiid: StringType('naviPoiId'),
    entr_location: StringType('entrLocation'),
    business_area: StringType('businessArea'),
    parking_type: StringType('parkingType'),
    exit_location: StringType('exitLocation'),
    match: StringType(),
    recommend: StringType(),
    timestamp: NumberType(convertTimestamp),
    alias: StringType(),
    indoor_map: StringType('indoorMap'),
    indoor_data: ObjectType(indoorDataType, 'indoordata'),
    indoor_src: ObjectType({ deep_src: StringType('deepSrc') }, 'indoorSrc'),
    deep_info: ObjectType({ deep_src: StringType('deepSrc') }, 'deepInfo'),
    rich_content: StringType('richContent'),
    groupbuy_num: StringType('groupBuyNum'),
    discount_num: StringType('discountNum'),
    biz_ext: ObjectType(bizExtType, 'bizExt'),
    event: StringType(),
    hot: NumberType(),
    rating: NumberType(),
    children: ArrayType(ObjectType(poiChildrenType)),
    photos: ArrayType(ObjectType({
        url: StringType(),
        title: StringType(),
    })),
};
var sugAddressType = {
    name: StringType(),
    address: StringType(),
    location: StringType(),
    country: StringType(),
    pname: StringType('pName'),
    cityname: StringType('cityName'),
    adcode: StringType('adCode'),
    adname: StringType('adName'),
    district: StringType(),
    aoi: StringType(),
    street: StringType(),
};
export var poiSearchResultType = {
    suggestion: ObjectType(suggestionType),
    sug_address: ObjectType(sugAddressType, 'sugAddress'),
    pois: ArrayType(ObjectType(poiType)),
};
//# sourceMappingURL=data:application/json;base64,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